/**
 * 2026「完成分院测试并加入House群」任务元数据（Paid Todo 真源）。
 * 落地页为既有 `/sorting-ceremony`（Activities/Digital），无独立页面。
 */

export const HOUSE_SORTING_TASK_KEY = '完成分院测试并加入House群_2026';

export const HOUSE_SORTING_ACTION_URL = '/sorting-ceremony';

/** hsylc_ddl.name：任务/页面开放开关（到点即开）。 */
export const HOUSE_SORTING_OPEN_DDL = '完成分院测试并加入House群开放';

/** 仅排序兜底；开放真源见 {@link HOUSE_SORTING_OPEN_DDL}。 */
export const HOUSE_SORTING_OPEN_AT = '2026-08-05';

/** hsylc_ddl.name：实际截止时间，用于逾期判定。 */
export const HOUSE_SORTING_DEADLINE_DDL = '完成分院测试并加入House群';

/** hsylc_ddl.name：展示截止时间，用于任务卡 DDL 文案。 */
export const HOUSE_SORTING_DISPLAY_DDL = '完成分院测试并加入House群_展示';

export const HOUSE_SORTING_OPEN_TAG = 'NEW';

/** 任务卡标题下说明文案（Figma `1:23`）。 */
export const HOUSE_SORTING_DESCRIPTION =
  '请完成分院测试，你的测试结果和你之前填写的分院问卷内容将决定你最后的分院，快来一探究竟！';
